import { graphql, useStaticQuery } from "gatsby";

const Events = (language) => {
    const eventData = useStaticQuery(graphql`
        fragment EventData on ContentfulEventConnection {
            nodes {
                id
                __typename
                ... on Node {
                    ...Event
                }
            }
        }

        fragment EventTaxonomyData on ContentfulTaxonomyConnection {
            nodes {
                id
                name
                terms {
                    ...EventTerm
                }
            }
        }

        query EventsQuery {
            eventsEnglish: allContentfulEvent(sort: { startDate: ASC }, filter: { node_locale: { eq: "en" } }) {
                ...EventData
            }
            pastEventsEnglish: allContentfulEvent(sort: { endDate: DESC }, filter: { node_locale: { eq: "en" } }) {
                ...EventData
            }
            eventTaxonomiesEnglish: allContentfulTaxonomy(
                filter: { node_locale: { eq: "en" }, title: { eq: "Event" } }
            ) {
                ...EventTaxonomyData
            }

            eventsGerman: allContentfulEvent(sort: { startDate: ASC }, filter: { node_locale: { eq: "de-DE" } }) {
                ...EventData
            }
            pastEventsGerman: allContentfulEvent(sort: { endDate: DESC }, filter: { node_locale: { eq: "de-DE" } }) {
                ...EventData
            }
            eventTaxonomiesGerman: allContentfulTaxonomy(
                filter: { node_locale: { eq: "de-DE" }, title: { eq: "Event" } }
            ) {
                ...EventTaxonomyData
            }

            eventsSpanish: allContentfulEvent(sort: { startDate: ASC }, filter: { node_locale: { eq: "es-ES" } }) {
                ...EventData
            }
            pastEventsSpanish: allContentfulEvent(sort: { endDate: DESC }, filter: { node_locale: { eq: "es-ES" } }) {
                ...EventData
            }
            eventTaxonomiesSpanish: allContentfulTaxonomy(
                filter: { node_locale: { eq: "es-ES" }, title: { eq: "Event" } }
            ) {
                ...EventTaxonomyData
            }

            eventsFrench: allContentfulEvent(sort: { startDate: ASC }, filter: { node_locale: { eq: "fr-FR" } }) {
                ...EventData
            }
            pastEventsFrench: allContentfulEvent(sort: { endDate: DESC }, filter: { node_locale: { eq: "fr-FR" } }) {
                ...EventData
            }
            eventTaxonomiesFrench: allContentfulTaxonomy(
                filter: { node_locale: { eq: "fr-FR" }, title: { eq: "Event" } }
            ) {
                ...EventTaxonomyData
            }

            eventsItalian: allContentfulEvent(sort: { startDate: ASC }, filter: { node_locale: { eq: "it-IT" } }) {
                ...EventData
            }
            pastEventsItalian: allContentfulEvent(sort: { endDate: DESC }, filter: { node_locale: { eq: "it-IT" } }) {
                ...EventData
            }
            eventTaxonomiesItalian: allContentfulTaxonomy(
                filter: { node_locale: { eq: "it-IT" }, title: { eq: "Event" } }
            ) {
                ...EventTaxonomyData
            }

            eventsPortuguese: allContentfulEvent(sort: { startDate: ASC }, filter: { node_locale: { eq: "pt-BR" } }) {
                ...EventData
            }
            pastEventsPortuguese: allContentfulEvent(
                sort: { endDate: DESC }
                filter: { node_locale: { eq: "pt-BR" } }
            ) {
                ...EventData
            }
            eventTaxonomiesPortuguese: allContentfulTaxonomy(
                filter: { node_locale: { eq: "pt-BR" }, title: { eq: "Event" } }
            ) {
                ...EventTaxonomyData
            }

            eventsJapanese: allContentfulEvent(sort: { startDate: ASC }, filter: { node_locale: { eq: "ja-JP" } }) {
                ...EventData
            }
            pastEventsJapanese: allContentfulEvent(sort: { endDate: DESC }, filter: { node_locale: { eq: "ja-JP" } }) {
                ...EventData
            }
            eventTaxonomiesJapanese: allContentfulTaxonomy(
                filter: { node_locale: { eq: "ja-JP" }, title: { eq: "Event" } }
            ) {
                ...EventTaxonomyData
            }
        }
    `);

    return {
        events: eventData[`events${language}`],
        pastEvents: eventData[`pastEvents${language}`],
        eventTaxonomies: eventData[`eventTaxonomies${language}`],
    };
};

export default Events;
